import { createSlice } from '@reduxjs/toolkit';
import {
  claimCashback,
  getCashback
} from '../views/CashbackBonus/CashbackBonus.actions';
import {
  CashbackBonusInfoModel,
  CashbackBonusStatusPerPackageModel
} from '../views/CashbackBonus/CashbackBonus.types';

export interface CashbackSliceType {
  loading: boolean;
  info: CashbackBonusInfoModel | null;
  statusPerPackage: CashbackBonusStatusPerPackageModel[];
}

const initialState = {
  loading: false,
  info: null,
  statusPerPackage: []
} as CashbackSliceType;

const cashbackSlice = createSlice({
  name: 'cashback',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getCashback.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCashback.fulfilled, (state, { payload }) => {
      state.loading = false;
      if (payload) {
        state.info = payload?.info;
        state.statusPerPackage = payload?.statusPerPackage;
      }
    });
    builder.addCase(getCashback.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(claimCashback.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(claimCashback.fulfilled, (state) => {
      state.loading = false;
      state.info!.canClaimCashbackBonus = false;
    });
    builder.addCase(claimCashback.rejected, (state) => {
      state.loading = false;
    });
  }
});

export default cashbackSlice.reducer;
